module.exports = __webpack_public_path__ + "img/dropsSlots-promotion.00424608.png";